import React from 'react'
import { useTranslation } from 'next-i18next'
import Link from 'next/link'
import { PrimaryButton } from 'shared/components/button'
import ErrorMessageRhf from 'shared/components/error-message-rhf'
import FormInputRhf from 'shared/components/form-input-rhf'
import { AuthRegularCardLayout } from 'modules/authentication/components/auth-regular-card-layout'
import { useRegisterForm } from '../hooks/use-register-form'

export const RegisterForm = () => {
  const { t } = useTranslation()

  const { handleSubmit, control, setValue, errors, isLoading, onSubmit } = useRegisterForm()

  return (
    <AuthRegularCardLayout title={t('modal.registraion.title')}>
      <form onSubmit={handleSubmit(onSubmit)} className="flex flex-col gap-5">
        <FormInputRhf
          required
          type="email"
          name="email"
          className="flex-auto text-[1.1rem] font-normal"
          label={t('security.login.username')}
          control={control}
          setValue={setValue}
          maxLength={180}
          rules={{ required: t('login.validation.email') }}
          error={errors.email?.message}
          autoComplete="email"
          autoCapitalize="none"
          spellCheck={false}
        />
        <ErrorMessageRhf errors={errors} fieldName="root" />
        <PrimaryButton isLoading={isLoading} type="submit" className="text-xl">
          {t('modal.register.submit')}
        </PrimaryButton>
        <>
          <p className="text-text-primary/50">{t('header_navigation.sing-in-question')}</p>
          <Link className="text-brand-primary" href={'/login'}>
            {t('security.registration.switcher.action_login')}
          </Link>
        </>
      </form>
    </AuthRegularCardLayout>
  )
}
